import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=491cb385&"
import script from "./BrandSelect.vue?vue&type=script&lang=js&"
export * from "./BrandSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports